const carouselData = [
  {
    title: '剑尊归来 · 年度最强玄幻',
    desc: '重生归来的剑尊，带着前世记忆逆天改命。全彩条漫，画风炸裂，打斗场面燃到飞起。当前连载突破200话，热度持续飙升中。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20banner%20with%20powerful%20swordsman%20silhouette%20against%20dramatic%20sunset%20sky%2C%20glowing%20sword%20with%20energy%20effects%2C%20cinematic%20wide%20composition%2C%20warm%20coral%20red%20and%20golden%20color%20palette%2C%20epic%20scale%20with%20mountains%20and%20clouds%2C%20anime-inspired%20illustration&width=1200&height=600&seq=manga-carousel-01&orientation=landscape',
    tag: '玄幻',
    rank: 'TOP 1',
  },
  {
    title: '我独自升级 · 系统流巅峰',
    desc: '从最弱到最强，见证一个猎人的传奇升级之路。暗黑奇幻风格，每一场战斗都让人肾上腺素飙升。韩漫全球现象级作品。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20banner%20with%20lone%20hunter%20figure%20surrounded%20by%20glowing%20blue%20energy%20in%20dark%20dungeon%2C%20dramatic%20chiaroscuro%20lighting%2C%20cinematic%20wide%20aspect%20ratio%2C%20intense%20atmosphere%2C%20mysterious%20shadows%2C%20anime%20art%20style&width=1200&height=600&seq=manga-carousel-02&orientation=landscape',
    tag: '热血',
    rank: 'TOP 2',
  },
  {
    title: '女神降临 · 甜蜜恋爱必读',
    desc: '化妆改变命运的校园浪漫故事。韩漫恋爱题材天花板，画风精致到每一帧都可以当壁纸。甜度爆表，治愈你的每一天。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20romantic%20manga%20banner%20with%20gorgeous%20female%20character%20in%20school%20setting%2C%20cherry%20blossoms%20and%20soft%20lighting%2C%20dreamy%20pastel%20color%20scheme%2C%20cinematic%20wide%20composition%2C%20warm%20pink%20and%20peach%20tones%2C%20shojo%20manga%20style&width=1200&height=600&seq=manga-carousel-03&orientation=landscape',
    tag: '恋爱',
    rank: 'TOP 3',
  },
  {
    title: '狐妖小红娘 · 国漫经典之作',
    desc: '以狐妖为线索，串联跨越千年的动人爱情。中国风画风融合现代漫画技法，每一页都如诗如画。连载多年，经久不衰的国漫之光。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manga%20banner%20with%20beautiful%20fox%20spirit%20in%20traditional%20hanfu%20under%20full%20moon%2C%20flowing%20ribbons%20and%20cherry%20blossoms%2C%20ethereal%20atmosphere%2C%20warm%20golden%20and%20vermilion%20tones%2C%20cinematic%20wide%20composition%2C%20elegant%20art%20style&width=1200&height=600&seq=manga-carousel-04&orientation=landscape',
    tag: '恋爱',
    rank: '精选',
  },
  {
    title: '全职高手 · 电竞题材巅峰',
    desc: '叶修的荣耀传奇，从网吧重新出发的世界冠军之路。国漫电竞题材开山之作，燃到头皮发麻的竞技场面，热血与梦想的完美结合。',
    img: 'https://readdy.ai/api/search-image?query=E-sports%20manga%20banner%20with%20dynamic%20gamer%20silhouette%20against%20glowing%20cyberpunk%20cityscape%2C%20keyboard%20and%20mouse%20action%20with%20light%20trails%2C%20cinematic%20wide%20composition%2C%20vibrant%20neon%20accent%20colors%2C%20energetic%20atmosphere%2C%20modern%20anime%20style&width=1200&height=600&seq=manga-carousel-05&orientation=landscape',
    tag: '热血',
    rank: '精选',
  },
  {
    title: '反派千金 · 异世界反套路',
    desc: '穿越成恶役千金怎么办？当然是逆天改命！反套路剧情让人欲罢不能，甜度超标的恋爱线和精彩的宫斗权谋完美交织。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20banner%20with%20noble%20lady%20in%20magnificent%20gown%20in%20grand%20palace%20ballroom%2C%20sparkling%20chandeliers%20and%20golden%20light%2C%20cinematic%20wide%20composition%2C%20warm%20amber%20and%20rose%20gold%20tones%2C%20romantic%20atmosphere%2C%20shojo%20manga%20art%20style&width=1200&height=600&seq=manga-carousel-06&orientation=landscape',
    tag: '恋爱',
    rank: '热门',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">精品专题</h2>
          <p className="text-sm text-foreground-500">深度解读热门作品，发现值得一读的好漫画</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {carouselData.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className={`group block rounded-2xl overflow-hidden bg-background-100 relative no-underline ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative ${i === 0 ? 'aspect-[21/9]' : 'aspect-[16/9]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 via-background-950/30 to-transparent"></div>
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-500 text-background-50 font-bold">
                    {item.tag}
                  </span>
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-500 text-background-50 font-bold">
                    {item.rank}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="text-base md:text-lg font-black text-background-50 mb-2">{item.title}</h3>
                  <p className="text-xs md:text-sm text-background-50/80 leading-relaxed max-w-2xl">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}